// reducer.js
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
/* ------------------------------------------------------ */

const initialState = {
  data: [],
  loading: false,
  error: null,
  fetchCounter: 0 
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) { 
    case "FETCH_POSTS_REQUEST":
      return { ...state, loading: true, error: null  };
    case "FETCH_POSTS_SUCCESS":
      return { ...state, loading: false, data: action.payload , fetchCounter: state.fetchCounter +1 };
    case "Fetch_POSTS_FAILURE":
      return { ...state, loading: false, error: action.error };
    case "FETCH_SAMPLE_REQUEST":
      return { ...state, loading: true, error: null  };
    case "FETCH_SAMPLE_SUCCESS":
      return { ...state, loading: false, data: action.payload , fetchCounter: state.fetchCounter +1 };
    case "Fetch_SAMPLE_FAILURE":
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export const store = createStore(
  dataReducer,
  composeWithDevTools(applyMiddleware(thunk))
);